const FALLBACK_LOCALE = 'en'

const informationSetPdfByLocale: Record<string, string> = {
  en: '/docs/R004_SI_Ed.09.2026_REVO_Good_Weather_Cover.pdf',
  fr: '/docs/R004_SI_Ed.09.2026_REVO_Garantie_Beau_Temps.pdf',
  it: '/docs/R004_SI_Ed.09.2026_REVO_Garanzia_Bel_Tempo.pdf',
}

const privacyPdfByLocale: Record<string, string> = {
  en: '/docs/Assicurazione-Meteo-Privacy_EN.pdf',
  fr: '/docs/Assicurazione-Meteo-Privacy_FR.pdf',
  it: '/docs/Assicurazione-Meteo-Privacy_IT.pdf',
}

function pdfPathForLocale(
  pdfByLocale: Record<string, string>,
  locale: string
): string {
  const language = locale.split('-')[0]
  const path = pdfByLocale[language] ?? pdfByLocale[FALLBACK_LOCALE]

  return encodeURI(path)
}

export function getInsurancePdfPaths(locale: string) {
  return {
    informationSetPdfPath: pdfPathForLocale(informationSetPdfByLocale, locale),
    privacyPdfPath: pdfPathForLocale(privacyPdfByLocale, locale),
  }
}
